<template>
    <div class="p-6 transition-all duration-300 bg-white rounded-lg dashboard-widget hover:shadow-lg">
        <div class="flex items-center justify-between mb-6">
            <h2 class="text-xl font-semibold text-gray-800">{{ module }}</h2>
            <a :href="data.link" class="text-sm font-medium transition-colors duration-200 mf-link text-wlPrimary hover:text-wlPrimary/80">
                Visit <i class="ml-1 fas fa-arrow-right"></i>
            </a>
        </div>

        <hr class="my-4 border-gray-100">

        <div v-for="item in data.data" :key="item.stat" class="mb-6 last:mb-0">
            <div class="flex items-end justify-between">
                <h1 class="text-3xl font-bold tracking-tight text-wlPrimary">
                    {{ Number(item.value).toLocaleString('en-US', {useGrouping: true, maximumFractionDigits: 0}).replace(/,/g, ' ') }}
                </h1>
                <div class="text-right">
                    <h3 class="text-sm font-medium text-gray-600">{{ item.stat }}</h3>
                    <small class="text-xs text-gray-400">{{ item.timeframe }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted } from 'vue';
    import axios from 'axios';

    const props = defineProps({
        module: String,
    });

    const data = ref([]);

    const fetchData = async () => {
        try {
            const response = await axios.get(route('boIndex.dashboardV2ModulesData', props.module));
            data.value = response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    onMounted(fetchData);
</script>

<style scoped>

.dashboard-widget:hover {
    transform: translateY(-2px);
}
</style>
